class DateRangeFilter {

    constructor() {
        return (items, dateFieldName, from, to) => {
            const dateFrom = new Date(from);
            const dateTo = new Date(to);
            const result = [];
            for (let i=0; i<items.length; i++){
                const itemStartDate = new Date(items[i][dateFieldName]);

                if (itemStartDate >= dateFrom && itemStartDate <= dateTo)  {
                    result.push(items[i]);
                }
            }
            return result;
      };

    }

    static filter() {
        return new DateRangeFilter();
    }

}

export default DateRangeFilter;



// WEBPACK FOOTER //
// ./app/common/date-range/date-range-filter.js